module.exports = __webpack_public_path__ + "img/icon-external-link.b56413f4.svg";